module.exports = __webpack_public_path__ + "static/media/contodos.c4ffd85f.png";